import React from "react";
import TopNavBar from "./TopNavBar";
import "../styles/AppLayout.css";

export default function AppLayout({ children }) {
  return (
    <>
      <TopNavBar />
      <div className="app-layout-shell">
        <main className="app-layout-content">{children}</main>
      </div>
    </>
  );
}
